document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-form-component').forEach((component) => initCustomSize(component));
});

function initCustomSize(component) {
  try {
    const fieldsWrapper = component.querySelector('[data-custom-size-fields]');
    if (!fieldsWrapper) return;

    const form = component.querySelector('form');
    const errorEl = component.querySelector('.product-form-text__error');

    const setError = (msg) => {
      if (!errorEl) return;
      errorEl.classList.remove('hidden');
      const existing = errorEl.childNodes[2];
      if (existing && existing.nodeType === Node.TEXT_NODE) {
        existing.textContent = msg;
      } else {
        errorEl.appendChild(document.createTextNode(msg));
      }
    };

    const clearError = () => {
      if (!errorEl) return;
      errorEl.classList.add('hidden');
      // remove any text nodes we added after the icon
      const nodes = Array.from(errorEl.childNodes).slice(2);
      nodes.forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE) n.remove();
      });
    };

    const applyRequired = (isRequired) => {
      const inputs = fieldsWrapper.querySelectorAll('input, textarea');
      inputs.forEach((el) => {
        el.required = !!isRequired;
      });
    };

    const resetInputs = () => {
      const inputs = fieldsWrapper.querySelectorAll('input, textarea');
      inputs.forEach((el) => {
        if (el.value) el.value = '';
      });
    };

    const toggleForVariant = (variant) => {
      const options = Array.isArray(variant?.options) ? variant.options : [];
      const title = typeof variant?.title === 'string' ? variant.title : '';
      const isCustom =
        title.toLowerCase().includes('custom') ||
        options.some((opt) => typeof opt === 'string' && opt.toLowerCase().includes('custom'));

      fieldsWrapper.classList.toggle('hidden', !isCustom);
      applyRequired(isCustom);
      if (!isCustom) {
        resetInputs();
        clearError();
      }
    };

    const target = component.closest('.shopify-section, dialog, product-card');
    if (target) {
      target.addEventListener('variant:update', (event) => {
        try {
          toggleForVariant(event.detail?.resource);
        } catch (e) {
          console.error(e);
        }
      }, { passive: true });
    }

    form?.addEventListener('submit', (event) => {
      if (fieldsWrapper.classList.contains('hidden')) return;
      const requiredInputs = Array.from(fieldsWrapper.querySelectorAll('input[required], textarea[required]'));
      const invalid = requiredInputs.find((el) => !el.value);
      if (invalid) {
        event.preventDefault();
        setError('Please fill all custom size fields.');
        invalid.focus();
      } else {
        clearError();
      }
    });

    fieldsWrapper.addEventListener('input', () => {
      if (fieldsWrapper.classList.contains('hidden')) return;
      const requiredInputs = Array.from(fieldsWrapper.querySelectorAll('input[required], textarea[required]'));
      const allValid = requiredInputs.every((el) => !!el.value);
      if (allValid) clearError();
    });
  } catch (e) {
    console.error(e);
  }
}


